import { call, takeLatest, put } from 'redux-saga/effects';

import { VisitStatuses } from 'shared/enums';
import VisitService from 'shared/services/VisitsService';

import {
  getActiveConsultations as getActiveConsultationsAction,
  setActiveConsultations,
  getActiveConsultationsFail
} from './consultationsQueue.redux';
import {
  TAction,
  TConsultationsQueueResponse,
  TFilterOptions
} from 'shared/types';

function* getActiveConsultations({
  payload
}: TAction<TFilterOptions | undefined>) {
  try {
    const result: TConsultationsQueueResponse = yield call(
      VisitService.getVisitsInQueue,
      { status: VisitStatuses.Active, ...(payload || {}) }
    );
    yield put(setActiveConsultations(result));
  } catch (error) {
    console.log('error', error);
    yield put(getActiveConsultationsFail());
  }
}

function* ConsultationsQueue() {
  yield takeLatest(getActiveConsultationsAction.type, getActiveConsultations);
}

export default ConsultationsQueue;
